import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { TraceHeaderService } from '@core/services/trace-header.service'

export const traceHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const traceHeader = inject(TraceHeaderService)

  return next(
    req.clone({
      setHeaders: {
        'x-session-id': traceHeader.getSessionId(),
      },
    })
  )
}
